"use client";

import { useRouter } from "next/router";

export const useBreadcrumbs = () => {
  const { asPath } = useRouter();

  const path = asPath.split("?")[0];
  const segments = path.split("/").filter(Boolean);

  // убираем текущую страницу (последний сегмент)
  return segments.slice(0, -1);
};
